angular.module 'zc.core'

.factory 'returnUrl', () ->

  class ReturnUrl
    @_url: null
    @set: (url) ->
      @_url = url
    @get: ->
      @_url




// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/services/return_url.service.coffee